import React from 'react';
import styles from './Legal.module.css';
import Container from '../components/shared/Container';

const TermsAndConditions = () => {
    return (
        <>
            <div className={styles.legalPage}>
                <Container>
                    <div className={styles.content}>
                        <h1>Algemene Voorwaarden</h1>
                        <p className={styles.lastUpdated}>Laatst bijgewerkt: {new Date().toLocaleDateString('nl-BE')}</p>

                        <section className={styles.section}>
                            <h2>1. Algemeen</h2>
                            <p>Deze algemene voorwaarden zijn van toepassing op het gebruik van het platform "Resto-Online", een handelsnaam van BrandVisionX, met maatschappelijke zetel te Tentoonstellingslaan 34 2020 Antwerpen , België, met BTW nummer BE 1007.972.431 Door gebruik te maken van dit platform verklaart u zich akkoord met deze voorwaarden.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>2. Definities</h2>
                            <ul>
                                <li><strong>Platform:</strong> De online bestelomgeving van Resto-Online waar klanten eten kunnen bestellen en afhalen bij aangesloten restaurants.</li>
                                <li><strong>Restaurant:</strong> De zelfstandige horecaonderneming die via het platform producten aanbiedt.</li>
                                <li><strong>Klant:</strong> De natuurlijke persoon of rechtspersoon die een bestelling plaatst via het platform.</li>
                                <li><strong>Beheerder:</strong> BrandVisionX, die het platform technisch en commercieel uitbaat.</li>
                            </ul>
                        </section>

                        <section className={styles.section}>
                            <h2>3. Dienstverlening</h2>
                            <p>Resto-Online fungeert als bemiddelingsplatform tussen restaurants en klanten. De koopovereenkomst komt tot stand tussen het restaurant en de klant. Resto-Online is geen partij in deze overeenkomst.</p>
                            <p>Resto-Online is niet verantwoordelijk voor de uitvoering van de bestelling, de kwaliteit van de producten of eventuele allergische reacties, tenzij anders wettelijk bepaald.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>4. Gebruik van het platform</h2>
                            <p>Restaurants zijn verantwoordelijk voor het correct invoeren van informatie zoals producten, prijzen, beschikbaarheid, allergenen en openingsuren.</p>
                            <p>Klanten zijn verantwoordelijk voor het verstrekken van juiste contact- en bestelgegevens. Misbruik van het platform, zoals frauduleuze bestellingen, is verboden.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>5. Allergeneninformatie</h2>
                            <p>Restaurants zijn wettelijk verplicht om correcte informatie te verschaffen over de 14 erkende allergenen. Deze informatie wordt weergegeven op het platform voor elk gerecht waar dit relevant is.</p>
                            <p>Klant is zelf verantwoordelijk om na te gaan of een gerecht allergenen bevat. Bij twijfel dient contact opgenomen te worden met het restaurant. Resto-Online is niet aansprakelijk voor fouten in allergeneninformatie die door het restaurant zijn verstrekt.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>6. Bestellingen en betalingen</h2>
                            <p>Een bestelling is pas definitief na bevestiging en succesvolle betaling. Resto-Online maakt gebruik van Stripe als betaalprovider. De voorwaarden van Stripe zijn van toepassing op transacties.</p>
                            <p>Het restaurant ontvangt de betaling rechtstreeks, na aftrek van de commissie van Resto-Online.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>7. Annulering en herroepingsrecht</h2>
                            <p>Volgens artikel VI.53 van het Wetboek van Economisch Recht is het herroepingsrecht uitgesloten voor bederfelijke of op maat gemaakte producten, zoals afhaalmaaltijden. Bestellingen kunnen enkel geannuleerd worden vóór de bereiding start. Neem hiervoor rechtstreeks contact op met het restaurant.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>8. Aansprakelijkheid</h2>
                            <p>Resto-Online is enkel aansprakelijk voor directe schade veroorzaakt door aantoonbare opzet of grove nalatigheid van haar kant. In alle andere gevallen, waaronder foutieve gegevens of allergeneninformatie door het restaurant, aanvaardt Resto-Online geen aansprakelijkheid.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>9. Intellectuele eigendom</h2>
                            <p>Alle inhoud, technologie en vormgeving van het platform zijn eigendom van BrandVisionX of haar licentiegevers. Het is verboden onderdelen van het platform te kopiëren, hergebruiken of verspreiden zonder schriftelijke toestemming.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>10. Privacy en gegevensbescherming</h2>
                            <p>Persoonsgegevens worden verwerkt conform de Algemene Verordening Gegevensbescherming (AVG). Details hierover zijn terug te vinden in onze <a href="/privacy">Privacyverklaring</a>.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>11. Wijzigingen</h2>
                            <p>Resto-Online behoudt zich het recht voor om deze voorwaarden te wijzigen. Wijzigingen worden van kracht zodra ze gepubliceerd worden op de website. Het is de verantwoordelijkheid van de gebruiker om de voorwaarden regelmatig na te lezen.</p>
                        </section>

                        <section className={styles.section}>
                            <h2>12. Toepasselijk recht en bevoegde rechtbank</h2>
                            <p>Op deze voorwaarden is het Belgisch recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechtbank van het arrondissement waar BrandVisionX gevestigd is, tenzij dwingend recht anders bepaalt.</p>
                        </section>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default TermsAndConditions;
